<template>
  <div>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardBody>
            <AppForm 
              :key="appFormKey"
              :vo-name="isEdit ? 'GlobalStyleGetVo' : 'GlobalStyleAddVo'"
              :data="tmpGlobalStyle" 
              @changed="onFormChange"
            />
          </CCardBody>
          <CCardFooter>
            <LoadingStateButton
              @click="onAddOrUpdateGlobalStyle"
              :text="i18nMessage.Apply"
              color="primary"
              :loading="updateGlobalStyleLoading"
            />
            <template v-if="isEdit">
              &nbsp;
              <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
            </template>
            &nbsp;
            <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        :show.sync="showDeleteModal"
        :centered="true"
        color="default"
      >
        {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{globalStyle.name}}</b>
        <br/><br/>
        <CInput
            :placeholder="i18nMessage.PleaseInputText"
            v-model="deleteConfirmText"
          />
        <template #header>
          <span class="modal-title">{{i18nMessage.Delete}}？</span>
          <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
        </template>
        <template #footer>
          <LoadingStateButton
            :disabled="deleteConfirmText !== globalStyle.name"
            @click="onDeleteGlobalStyle"
            :text="i18nMessage.Apply"
            color="danger"
            :loading="deleteGlobalStyleLoading"
          />
          <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
        </template>
      </CModal>
    </CRow>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID, isEmpty } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'SectionBuilder',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpGlobalStyle: {},
      updateGlobalStyleLoading: false,
      deleteGlobalStyleLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      globalStyle: state => state.pageBuilder.globalStyle,
    }),
  },
  methods: {
    ...mapActions({
      getGlobalStyle: 'pageBuilder/getGlobalStyle',
      addGlobalStyle: 'pageBuilder/addGlobalStyle',
      updateGlobalStyle: 'pageBuilder/updateGlobalStyle',
      deleteGlobalStyle: 'pageBuilder/deleteGlobalStyle',
    }),
    ...mapMutations({
      setGlobalStyle: 'pageBuilder/setGlobalStyle',
    }),
    onDeleteGlobalStyle () {
      this.deleteGlobalStyleLoading = true
      this.deleteGlobalStyle(this.globalStyle.id)
          .then(() => {
            this.deleteGlobalStyleLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteGlobalStyleLoading = false
            this.showDeleteModal = false
          })
    },
    goBack() {
      this.$router.push({path: '/global-style'})
    },
    onEditorContentChange (template, style) {
      this.tmpGlobalStyle = {
        ...this.tmpGlobalStyle,
        template,
        style,
      }
    },
    onFormChange (data) {
      this.tmpGlobalStyle = {...data}
    },
    onAddOrUpdateGlobalStyle () {
      if (isEmpty(this.tmpGlobalStyle)) {
        return
      }
      if (this.tmpGlobalStyle.id) {
        this.updateGlobalStyleLoading = true
        this.updateGlobalStyle(this.tmpGlobalStyle)
          .then(() => {
            this.updateGlobalStyleLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateGlobalStyleLoading = false
          })
      } else {
        this.updateGlobalStyleLoading = true
        this.addGlobalStyle(this.tmpGlobalStyle)
          .then(() => {
            this.updateGlobalStyleLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateGlobalStyleLoading = false
          })
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getGlobalStyle(this.$route.params.id).then(() => {
        this.tmpGlobalStyle = this.globalStyle
      })
    }
  },
  destroyed() {
    this.setGlobalStyle({})
  }
}
</script>
